var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgServiceOnpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 408 304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M425.436 240.028a394.631 394.631 0 0 0-110.872-99.425C233.842 92.471 91.266 48.22 9.959 113.6c-24.875 20.013-54.48 58.696-44.554 89.552 15.228 47.467 112.002 72.636 183.157 45.447a156.55 156.55 0 0 0 44.793-26.577",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M412.946 266.592a394.48 394.48 0 0 0-97.81-112.289C240.938 96.604 104.872 35.158 16.164 90.066c-27.147 16.797-61.256 51.547-55.223 83.386 9.301 48.995 102.221 85.858 176.18 67.612a156.278 156.278 0 0 0 47.73-20.876",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.28 291.402a394.473 394.473 0 0 0-83.273-123.478c-66.545-66.364-194-144.075-288.82-100.489-29.007 13.289-67.13 43.627-65.11 75.971 3.295 49.793 90.994 97.804 166.6 88.782a156.636 156.636 0 0 0 49.935-14.857",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M378.677 314.138a394.492 394.492 0 0 0-67.461-132.766C253.322 107.328 136.364 14.533 36.933 46.147c-30.43 9.66-71.993 35.042-73.893 67.4-2.95 49.779 78.198 108.196 154.376 108.541a156.093 156.093 0 0 0 51.37-8.598",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M357.431 334.39a394.425 394.425 0 0 0-50.64-139.995C258.438 113.733 153.771 7.278 51.204 26.427c-31.386 5.847-75.74 25.94-81.613 57.819-9.036 49.035 64.312 116.939 139.866 126.693a156.436 156.436 0 0 0 52.047-2.232",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.858 351.878a394.406 394.406 0 0 0-32.98-145.204c-38.082-85.938-128.89-204.446-233.012-198-31.89 1.953-78.397 16.437-88.11 47.347-15.055 47.493 49.377 123.956 123.137 142.865a156.325 156.325 0 0 0 51.928 4.186",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.32 366.349a394.695 394.695 0 0 0-14.962-148.181C266.132 128.204 190.591-.562 86.443-7.021 54.553-8.988 6.717-.377-6.81 29.137-27.525 74.492 27.034 158.29 97.937 186.13a156.535 156.535 0 0 0 51.011 10.538",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.186 377.552a394.334 394.334 0 0 0 3.362-148.832C268.589 136.045 209.433-1.04 106.879-20.243c-31.386-5.873-80.005-3.176-97 24.425-26.137 42.523 17.7 132.328 84.655 168.672a156.236 156.236 0 0 0 49.337 16.717",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.884 385.352a394.46 394.46 0 0 0 21.645-147.344C270.052 144.111 228.195.806 128.777-30.861c-30.415-9.687-79.034-12.982-99.258 12.319C-1.628 20.38 30.847 114.955 92.82 159.26a156.484 156.484 0 0 0 46.905 22.657",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.81 389.604a394.675 394.675 0 0 0 39.571-143.516c7.109-93.725-16.822-241.096-111.616-284.736-28.994-13.355-76.803-22.59-100.016 0C16.098-3.87 36.707 93.972 92.767 145.56a156.465 156.465 0 0 0 43.77 28.252",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M194.498 390.256a394.41 394.41 0 0 0 56.924-137.617c18.603-92.143 12.929-241.335-75.74-296.336C148.536-60.52 102.228-75.59 76.41-55.962 36.68-25.771 45.105 73.88 94.402 131.938a156.263 156.263 0 0 0 39.969 33.421",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.344 387.306a394.28 394.28 0 0 0 73.401-129.578c29.751-89.166 42.521-237.866-38.786-303.352-24.915-20.026-69.03-40.663-97.067-24.425-43.118 25.05-46.998 124.913-5.208 188.699a156.207 156.207 0 0 0 35.557 38.072",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.67 380.781a394.27 394.27 0 0 0 88.775-119.598c40.474-84.821 71.394-230.89-1.223-305.81-22.217-22.923-63.461-48.81-93.266-36.052-45.869 19.56-62 118.268-28.355 186.585a156.565 156.565 0 0 0 30.561 42.165",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.072 370.788a394.389 394.389 0 0 0 102.78-107.758c50.599-79.266 99.232-220.365 36.381-303.658-19.24-25.434-56.977-56.25-88.123-47.294-47.916 13.767-76.059 109.71-51.065 181.682a156.291 156.291 0 0 0 25.247 45.593",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.96 357.486a394.288 394.288 0 0 0 115.245-94.349c59.953-72.383 125.568-206.492 73.414-296.881-15.945-27.654-49.629-62.829-81.653-57.766-49.244 7.774-88.947 99.545-72.989 174.081a156.43 156.43 0 0 0 19.4 48.357",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.578 341.061a394.62 394.62 0 0 0 125.967-79.439C252.923 197.146 334.523 72.14 293.876-23.99c-12.438-29.408-41.538-68.45-73.933-67.32-49.828 1.66-100.507 87.85-93.824 163.742a156.192 156.192 0 0 0 13.288 50.364",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.454 321.766a394.346 394.346 0 0 0 134.763-63.347c75.793-55.586 172.182-169.642 143.6-269.998-8.73-30.71-32.807-73.087-65.11-75.944-49.655-4.465-110.553 74.841-113.25 150.972a156.51 156.51 0 0 0 7.029 51.626",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.855 299.906a394.303 394.303 0 0 0 141.539-46.31C240.446 207.75 350.042 106.398 334.097 3.291c-4.89-31.56-23.586-76.516-55.263-83.372C230.108-90.62 159.923-19.392 147.897 55.835a156.305 156.305 0 0 0 .625 52.091",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M.1 275.801a394.184 394.184 0 0 0 146.164-28.557c87.047-35.415 208.297-122.535 205.108-226.824-.97-31.892-14.005-78.841-44.607-89.525C259.687-85.556 181.29-23.538 160.123 49.682a156.624 156.624 0 0 0-5.78 51.825",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.56 249.822a394.233 394.233 0 0 0 148.556-10.379c90.742-24.451 221.771-95.997 231.431-199.9 2.95-31.787-4.212-79.958-33.219-94.35-44.686-22.098-130.126 29.847-160.129 99.878a156.466 156.466 0 0 0-12.105 50.67",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-23.938 222.367a394.495 394.495 0 0 0 148.716 7.973c93.013-13.115 231.896-68.011 254.232-169.934 6.91-31.215 5.647-79.958-21.419-97.738-41.631-27.401-132.797 13.634-171.185 79.426a156.514 156.514 0 0 0-18.231 48.809",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-30.848 193.837a394.485 394.485 0 0 0 146.603 26.165c93.97-1.581 238.486-39.002 273.194-137.404 10.63-30.112 15.413-78.576-9.302-99.598-37.949-32.345-133.474-2.804-179.648 57.792a156.271 156.271 0 0 0-24.025 46.191",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-34.209 164.668a394.24 394.24 0 0 0 142.271 43.986c93.452 9.993 241.476-9.395 288.009-102.788 14.245-28.584 24.955-76.077 3.057-99.983-33.671-36.757-132.106-19.176-185.39 35.28A156.48 156.48 0 0 0 184.16 84.1",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-33.97 135.314a394.301 394.301 0 0 0 135.787 61.127c91.525 21.395 240.798 20.358 298.453-66.616 17.646-26.577 34.123-72.436 15.321-98.84C386.69-9.64 286.847-4.283 227.279 43.197a156.472 156.472 0 0 0-34.628 38.922",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M-30.104 106.211A394.633 394.633 0 0 0 97.14 183.578c88.203 32.477 236.52 49.792 304.393-29.434 20.769-24.239 42.747-67.693 27.346-96.21-23.705-43.852-123.442-50.829-188.392-11.016a156.725 156.725 0 0 0-39.159 34.364",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.702 77.814A394.662 394.662 0 0 0 94.07 170.223c83.539 43.068 228.547 78.482 305.695 8.199 23.599-21.501 50.746-61.925 38.959-92.117C420.6 39.848 322.471 20.686 253.123 52.207a156.59 156.59 0 0 0-43.079 29.235",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.873 50.519A394.469 394.469 0 0 0 92.674 156.588c77.6 53.022 217.187 105.977 302.36 45.713 26.071-18.444 57.974-55.227 49.988-86.641-12.277-48.318-107.311-79.4-180.02-56.636a156.45 156.45 0 0 0-46.348 23.746",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.238 24.78a394.29 394.29 0 0 0 90.715 118.108c70.504 62.151 202.517 131.863 294.454 82.522 28.13-15.095 64.326-47.679 60.26-79.838-6.259-49.513-96.748-92.036-171.69-78.323a156.495 156.495 0 0 0-48.925 17.9",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M19.407.966A394.18 394.18 0 0 0 94.921 129.28c62.332 70.429 184.778 155.795 282.083 118.135 29.778-11.534 69.694-39.414 69.601-71.825-.12-49.858-84.709-103.186-160.781-98.84a156.118 156.118 0 0 0-50.745 11.76",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M39.364-20.562a394.093 394.093 0 0 0 59.17 136.674c53.217 77.472 164.235 177.283 265.434 151.862 30.96-7.787 73.999-30.564 77.905-62.736 5.993-49.5-71.394-112.807-147.399-117.843a156.289 156.289 0 0 0-51.822 5.435",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M61.808-39.485a394.369 394.369 0 0 0 41.935 142.906c43.292 83.426 141.208 196.127 244.759 183.383 31.691-3.92 77.201-21.262 85.041-52.676 12.038-48.384-56.991-120.727-131.8-135.066a156.786 156.786 0 0 0-52.088-.983",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.416-55.431A394.605 394.605 0 0 0 110.467 91.54c32.714 88.077 116.001 211.953 220.375 211.98 31.891 0 79.235-11.575 90.861-41.833 17.886-46.51-41.723-126.813-114.207-150.241a156.787 156.787 0 0 0-51.569-7.415",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112.805-68.334a394.31 394.31 0 0 0 5.807 148.832c21.646 91.466 89.12 224.578 192.671 237.494 31.691 3.987 80.045-1.754 95.299-30.351 23.479-43.985-25.818-130.986-94.874-163.131a156.257 156.257 0 0 0-50.267-13.661",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M140.577-77.862a394.426 394.426 0 0 0-12.531 148.407c10.245 93.432 60.831 233.879 162.017 259.367 30.96 7.8 79.659 8.106 98.328-18.391 28.702-40.77-9.54-133.166-74.118-173.563a156.503 156.503 0 0 0-48.208-19.734",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M169.331-83.895A394.373 394.373 0 0 0 138.636 61.84c-1.329 93.99 31.625 239.607 128.89 277.32 29.764 11.548 78.052 17.833 99.83-6.179 33.485-36.929 6.896-133.325-52.234-181.35a156.415 156.415 0 0 0-45.417-25.514",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.564-86.353a394.418 394.418 0 0 0-48.341 140.859c-12.862 93.113 1.953 241.68 93.864 291.02 28.117 15.123 75.275 27.295 99.83 6.14 37.777-32.531 23.227-131.465-29.552-186.4a156.447 156.447 0 0 0-41.949-30.896",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M227.876-85.198A394.37 394.37 0 0 0 162.594 48.66c-24.197 90.814-27.811 240.085 57.389 300.389 26.057 18.458 71.355 36.331 98.329 18.351 41.497-27.64 39.212-127.57-6.418-188.618a156.375 156.375 0 0 0-37.83-35.813",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M256.843-80.453a394.313 394.313 0 0 0-81.227 124.82c-35.186 87.16-57.058 234.849 20.037 305.159 23.586 21.528 66.345 44.823 95.313 30.311 44.58-22.338 54.598-121.829 16.808-187.98a156.458 156.458 0 0 0-33.139-40.198",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M285.014-72.175A394.413 394.413 0 0 0 189.051 41.71c-45.617 82.177-85.48 226.066-17.606 305.319 20.768 24.252 60.339 52.636 90.9 41.779 46.972-16.69 69.096-114.189 39.77-184.485a156.385 156.385 0 0 0-27.904-43.959",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M311.948-60.507A394.47 394.47 0 0 0 202.723 40.726c-55.383 75.944-112.613 213.84-54.997 300.84 17.632 26.578 53.403 59.653 85.041 52.637 48.672-10.791 82.662-104.834 62.146-178.201a156.362 156.362 0 0 0-22.35-47.068",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M337.233-45.61a394.392 394.392 0 0 0-120.825 87.04c-64.352 68.569-138.031 198.372-91.551 291.791 14.217 28.597 45.683 65.765 77.932 62.696 49.642-4.731 94.927-93.885 83.579-169.204a156.827 156.827 0 0 0-16.384-49.461",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M360.513-27.724a394.471 394.471 0 0 0-130.618 71.532c-72.218 60.144-161.351 179.915-126.711 278.33 10.631 30.125 37.206 70.882 69.654 71.759 49.829 1.408 105.73-81.499 103.724-157.656-.542-17.47-4-34.726-10.232-51.055",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M381.415-7.114a394.63 394.63 0 0 0-138.418 54.936C163.923 98.637 60.757 206.54 83.041 308.478c6.83 31.201 28.263 74.921 60.299 79.811 49.284 7.521 114.951-67.891 122.326-143.716a156.51 156.51 0 0 0-3.84-51.959",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M399.62 15.916A394.377 394.377 0 0 0 255.502 53.43C170.793 94.132 55.137 188.548 64.732 292.452c2.949 31.786 18.841 77.818 50.04 86.615 47.982 13.514 122.419-53.261 139.042-127.571a156.3 156.3 0 0 0 2.591-52.038",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M414.859 41.004A394.351 394.351 0 0 0 267.22 60.525C178.193 90.505 51.775 169.984 48.532 274.286c-.983 31.893 9.129 79.545 39.013 92.103 45.909 19.362 128.026-37.779 153.671-109.538a156.323 156.323 0 0 0 8.956-51.32",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M426.899 67.78a394.284 394.284 0 0 0-148.915 1.223C185.901 87.82 50.766 151.167 34.688 254.273c-4.904 31.547-.705 80.064 27.399 96.196 43.238 24.824 131.707-21.78 165.962-89.817a156.215 156.215 0 0 0 15.201-49.833",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M435.563 95.833a394.103 394.103 0 0 0-147.972-17.05c-93.664 7.31-235.603 53.567-264.184 153.923-8.744 30.71-10.55 79.373 15.36 98.84 39.863 29.94 133.395-5.435 175.756-68.742a156.833 156.833 0 0 0 21.26-47.586",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M440.704 124.736a394.103 394.103 0 0 0-144.702-35.148c-93.891-4.213-240.507 24.238-281.14 120.328-12.45 29.394-20.224 77.472 3.096 99.97 35.876 34.55 133.049 11.016 182.864-46.616a156.394 156.394 0 0 0 26.894-44.624",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M442.273 154.037a394.531 394.531 0 0 0-139.308-52.662c-92.655-15.72-241.596-5.502-293.79 84.861-15.945 27.64-29.578 74.416-9.195 99.598 31.346 38.763 130.671 27.268 187.197-23.8a156.074 156.074 0 0 0 32.169-40.969",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M440.213 183.325a394.45 394.45 0 0 0-131.773-69.38C218.416 86.956 69.342 78.784 6.452 162.063c-19.254 25.475-38.535 70.204-21.38 97.712 26.362 42.324 126.339 43.121 188.684-.612a156.372 156.372 0 0 0 36.966-36.703",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M434.578 212.135a394.66 394.66 0 0 0-122.246-85.047C226.294 89.242 79.359 62.825 6.716 137.719c-22.244 22.923-46.852 64.941-33.22 94.349 20.942 45.181 120.081 58.324 187.357 22.591a156.501 156.501 0 0 0 41.191-31.893",
    stroke: "#12A628",
    strokeMiterlimit: 10,
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgServiceOnpt);
export default __webpack_public_path__ + "static/media/bg-service-onpt.c519e7855ad5554a6fe7fcc8fca1566f.svg";
export { ForwardRef as ReactComponent };